/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck
/* eslint-disable @typescript-eslint/no-explicit-any */
declare let hall: any;
declare let base: any;
declare let WebDefine: any;
declare let PopupViews: any;
declare let log: any;
import { ModuleBase } from './ModuleBase'

export class BonanzaModule extends ModuleBase {
  public info: any = null
  public spinReward: any = null //抽奖中奖金额

  init(): void {}

  onClear(): void {}

  onLoad(): void {}

  onDestroy(): void {}

  inits2c(): void {}

  onPreloadData(): void {
    this.sendBonanzaConfig()
  }

  //获取累计充值信息
  sendBonanzaConfig() {
    const data = {
      uid: hall.userModule.userId,
      cid: base.channelId,
    }
    base.httpUtil
      .postJson(WebDefine.ActiveGearConfig, data)
      .then((respJson) => {
        if (respJson.code == 200) {
          this.info = respJson.data
          //let goodsInfo = hall.addCashModule.getGoodsInfos()
          //if (goodsInfo && goodsInfo.first_pay == 0) {
          //    hall.bonanzaModule.popupView()
          //}

          hall.eventDispatcher.emit(hall.EventDefine.OnBonanzaInfoChange)
          hall.eventDispatcher.emit(hall.EventDefine.ChangeBindActivityRed) //刷新累计充值红点
        }
      })
      .catch((_error: any) => {
        log('tryGetRuleInfos_ failFun', error.message, error.name)
      })
  }

  //领取累计充值奖励
  sendBonanzaRew(gear, gold) {
    this.spinReward = gold
    const data = {
      uid: hall.userModule.userId,
      cid: base.channelId,
      rid: this.info.rid,
      recharge_gear: gear,
      recharge_gold: gold,
    }
    base.httpUtil
      .postJson(WebDefine.ActiveRecordAdd, data)
      .then((respJson) => {
        if (respJson.code == 200) {
          //this.spinReward = respJson.data

          hall.eventDispatcher.emit(hall.EventDefine.OnBonanzaInfoReward)
          hall.eventDispatcher.emit(hall.EventDefine.ChangeBindActivityRed) //刷新累计充值红点
        }
      })
      .catch((_error: any) => {
        log('tryGetRuleInfos_ failFun', error.message, error.name)
      })
  }

  //是否侧边栏展示这个活动
  isShowBonanzaBind() {
    if (this.info && this.info.params) {
      const GetRewardNum = this.info.gameRechargeRecord.length
      if (this.info.gameRechargeRecord.length >= 10) {
        return false
      }
      const le = Number(this.info.gold)
      const tr = Number(this.info.params[GetRewardNum]['recharge_gear'])
      return le > tr
    }

    return false
  }

  // 是否需要弹窗
  popupView() {
    if (this.info) {
      const GetRewardNum = this.info.gameRechargeRecord.length
      if (this.info.gameRechargeRecord.length >= 10) {
        return false
      }
      const le = Number(this.info.gold)
      const tr = Number(this.info.params[GetRewardNum]['recharge_gear'])
      if (le > tr) {
        hall.popupViewModule.addPopupView(PopupViews.BonanzaPanel)
      }
    }
  }
}
